import BaseComponent from "@js/components/base_component.jsx";

import EuiSearchBar from "@js/components/eui/search_bar.jsx";

class EuiPausedDomainsIndex extends BaseComponent {

  render() {
    const table = this.props.paused_domains;

    return (
      <div>
        <EuiSearchBar
            q={ this.props.q }
            placeholder={ I18n.t("placeholders.search_paused_domains") }
            route={ (q) => Routes.eui_virtual_mta_paused_domains_path(q ? { q: q } : {}) }
        />

        {
            table && table.total > 0 ? (
                <div>
                <table className="table">
                    <thead>
                    <tr>
                        <th style={{width: "225px"}}>{ I18n.t("paused_domains_table.time") }</th>
                        <th style={{width: "175px"}}>{ I18n.t("paused_domains_table.recipient_domain") }</th>
                        <th style={{width: "175px"}}>{ I18n.t("paused_domains_table.throttle") }</th>
                        <th style={{width: "175px"}}>{ I18n.t("paused_domains_table.message_domain") }</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>{_.map(table.data, this._renderRow)}</tbody>
                </table>
                <Paginator entity={table} />
                </div>
            ) : (
                <EmptyTableNotification
                    text={ I18n.t("empty_table.paused_domains") }
                    color="gray"
                    icon="check-circle"
                    offerNew={ false }
                />
            )
        }
      </div>
    );
  }

  _renderRow(row, i) {
    return (
      <tr key={i}>
        <td>
          {row.pause_began_at_pretty}
          <br />
          <small>until</small>
          <br />
          {row.pause_ends_at_pretty}
        </td>
        <td>
          {row.recipient_domain}
        </td>
        <td>
          {
            row.throttle_id ? (
              <React.Fragment>
                <a href={ Routes.eui_virtual_mta_ip_address_path(row.throttle_ip_address.id) }>{row.throttle_ip_address.name}</a>
                <br />
                <br />
                <a href={ Routes.eui_virtual_mta_eng_throttle_path(row.throttle_id) }>
                  {row.throttle_domains.slice(0, 3).reduce((a, e, i) => [ ...a, <br key={ i } />, e ])}
                  {row.throttle_domains.length > 3 && (
                    <span>
                      <br />
                      &hellip;
                    </span>
                  )}
                </a>
              </React.Fragment>
            ) : (
              "-"
            )
          }
        </td>
        <td>
          <small>{row.affect_percentage}&nbsp;of&nbsp;messages&nbsp;from</small>
          <br />
          {row.domain}
          <br />
          <small>{I18n.t(`domain_pause_types.${row.pause_type}`)}</small>
        </td>
        <td className="actions">
          <ButtonWithIcon
            type="index"
            href={ Routes.unpause_eui_virtual_mta_paused_domain_path(row.id, { q: this.props.q }) }
            tooltip="paused_domain_unpause"
            icon="play"
          />
        </td>
      </tr>
    );
  }

}

export default EuiPausedDomainsIndex;
